import React from 'react';
import PropTypes from 'prop-types';
import SvgIcon from '../Svg/SvgIcon';
import { Button, makeStyles, alpha } from '@material-ui/core';

import './ButtonCard.scss';
import { SESSION_STORAGE_AMERICO_OBJECT_KEY, getSessionStorageItem } from '../../../sessionStorage';

const useStyles = makeStyles(theme => ({
  primary: {
    '&::before': {
      backgroundColor: alpha(theme.palette.primary.main, .6),
    }
  },
}));

export default function ButtonCard(props) {

  const color = props.color ? props.color : 'primary';

  const borderColor = color === 'primary' ? useStyles().primary : '';

  const onProductClick = (url) => {
    if(url === '/quote/term-life-insurance/loan-protector' || url === '/landing/loan-protector'){
      const sessionStorageData = getSessionStorageItem(SESSION_STORAGE_AMERICO_OBJECT_KEY);
      if(sessionStorageData) {
        sessionStorage.removeItem(SESSION_STORAGE_AMERICO_OBJECT_KEY);
        sessionStorage.removeItem('AMERICO_QUOTE');
      }
      url = 'landing/loan-protection';
    }
    window.location.href = url;
  }

  return (

    <div className={`button-card shadow-sm d-flex align-items-center tall ${borderColor}`}>
      <Button type="submit" onClick={() => onProductClick(props.href)} variant="contained" target={props.target} color={color} fullWidth ><span className="name"><SvgIcon iconName={props.icon} /><br />{props.name}</span></Button>
    </div>
  )
}

ButtonCard.propTypes = {
  name: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.object.isRequired,
  ]),
  icon: PropTypes.string.isRequired,
  target: PropTypes.string,
  href: PropTypes.string,
}



// WEBPACK FOOTER //
// ./src/components/Helpers/Buttons/ButtonCard.js